import React from 'react';
import {useState } from 'react'

function RecipeIngredients({ Recipe_Ingredients, ingredientsVisible}) {
    const [showIngredients, setShowIngredients] = useState(false);

    function toggleIngredients() {
        setShowIngredients(!showIngredients);
    }

    return (
        <div>
            <button className="button" onClick={toggleIngredients} style={{ display: ingredientsVisible ? "initial" : "none" }} > {showIngredients ? "Hide Recipe Ingredients" : "See Recipe Ingredients"} </button>
            <div style={{ display: showIngredients ? 'block' : 'none' }}>
                <ul className="recipe-ingredients-list">
                    {Recipe_Ingredients.map((ingredient, index) => (
                        <li key={index }>{ingredient.Ingredient_Name}: {ingredient.Ingredient_Quantity}</li>
                    ))} 
                </ul>
            </div>
        </div>
    )
}

export default RecipeIngredients;